import { render } from "./KappPostsNew.vue?vue&type=template&id=5105c8f4&scoped=true"
import script from "./KappPostsNew.vue?vue&type=script&lang=js"
export * from "./KappPostsNew.vue?vue&type=script&lang=js"

import "./KappPostsNew.vue?vue&type=style&index=0&id=5105c8f4&scoped=true&lang=css"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5105c8f4"]])

export default __exports__